import { State } from '..';
import { KeysOfType } from 'component_utils/typescriptUtils';
import { IItem } from 'interfaces';
import serialSfx from 'audio/serialSound.mp3';

interface EventProps {}

interface Config<S, P, A, R> {
  nextStateIfNormal: number;
  nextStateIfBatch: number;
  nextStateIfSerial: number;
  itemKey: KeysOfType<S, IItem>;

  playSound?: boolean;
  playSoundIfNormal?: boolean;
  playSoundIfBatch?: boolean;
  playSoundIfSerial?: boolean;
}

const StateItemSplit = function <S, P extends EventProps, A extends { hint: string }, R>({
  nextStateIfNormal,
  nextStateIfBatch,
  nextStateIfSerial,
  itemKey,
  playSound,
  playSoundIfBatch,
  playSoundIfNormal,
  playSoundIfSerial,
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      const item = args.state[itemKey] as unknown as IItem;
      let nextState;
      if (item.managedBy === 'SERIAL_NUMBER') {
        nextState = nextStateIfSerial;
        if (playSound || playSoundIfSerial) {
          const audio = new Audio(serialSfx);
          audio.play();
        }
      } else if (item.managedBy === 'BATCH_NUMBER') {
        nextState = nextStateIfBatch;
        if (playSound || playSoundIfBatch) {
          // const audio = new Audio(serialSfx)
          // audio.play()
        }
      } else {
        nextState = nextStateIfNormal;
        if (playSound || playSoundIfNormal) {
          // const audio = new Audio(serialSfx)
          // audio.play()
        }
      }

      return {
        type: 'MOVE',
        nextState,
      };
    },

    nodeName: 'T.states.itemSplit',
    outputs: [
      {
        name: 'normal',
        to: nextStateIfNormal,
      },
      {
        name: 'batch',
        to: nextStateIfBatch,
      },
      {
        name: 'serial',
        to: nextStateIfSerial,
      },
    ],
  };
};

export default StateItemSplit;
